export default "__VITE_ASSET__igs5lwYL__"